export default __webpack_public_path__ + "static/media/wordLogo.8aa58f59.png";